<div class="dd1pnds-app-avvc-container">

	<!-- Page maintenance (ngIf) -->
	<div *ngIf="isSiteIndispo">
		<dd1pnds-ng-maintenance></dd1pnds-ng-maintenance>
	</div>

	<!-- Page maintenance (ngIf) -->
	<div *ngIf="cmsContentLoaded">
		<span #titleBlock
			id="titlePage"
			class="sr-only"
			aria-live="assertive"
			aria-atomic="true"
			tabindex="-1">
			{{ pageTitle }}
		</span>

		<a class="skiplink"
			[href]="activeDatas.mainHrefLink">{{contentLink}}
		</a>

		<dd1pnds-ng-header #header
			[headerContent]="headerAppContent"
			[isLogged]="isLogged"
			[userInfo]="extranaute"
			[activeOngletId]="activeDatas.activeOngletId"
			(navLinkClicked)="redirectPage($event)">
		</dd1pnds-ng-header>

		<div id="dd1pnds-app-avc-body" class="dd1pnds-app-page-container">
			<main role="main" id="main" tabindex="-1">
				<router-outlet></router-outlet>
				<button *ngIf= "windowScrolled"
					class="back-to-top-button"
					[class.position-bottom]="windowScrolledBottom"
					(click)="backtoTop()"
					mat-fab>
					<mat-icon aria-hidden="true"> keyboard_arrow_up </mat-icon>
				</button>
			</main>
		</div>

		<dd1pnds-ng-footer #footer
			[footerContent]="footerAppContent"
			(navLinkClicked)="redirectPage($event)">
		</dd1pnds-ng-footer>
	</div>
</div>
